import { LoadableAfterPaint } from '@confluence/loadable';

export const BlankPageQuickActions = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlankPageQuickActions" */ '../src/BlankPageQuickActions'
			)
		).BlankPageQuickActions,
});
